import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoCe: CultureInfo = {
  name: 'ce',
  displayName: 'нохчийн',
  iso3LanguageCode: 'che',
  iso2LanguageCode: 'ce',
  ietfLanguageTag: 'ce',
  parent: null
};
